import { Box, Paper, Stack, styled } from "@mui/material";

const Card = styled(Paper)(() => ({
  boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.12)",
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

const DescriptionStack = styled(Stack)(({ bgcolor, color }) => ({
  padding: "8px",
  borderRadius: "8px 8px 0px 0px",
  backgroundColor: bgcolor,
  alignItems: "center",
  justifyContent: "center",
  color,
}));

const DetailsStack = styled(Stack)(({ theme }) => ({
  padding: "16px",
  backgroundColor: theme.palette.primary.main,

  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  justifyContent: "space-between",
}));

const LotBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isSelected",
})(({ theme, isSelected, isPromo }) => ({
  height: "40px",
  width: "fit-content",
  minWidth: "100px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "1px solid rgba(239, 96, 163, 1)",
  padding: "12px 8px",
  borderRadius: "16px",
  color: theme.palette.secondary.light,
  "&:hover": {
    cursor: "pointer",
    background: "rgba(239, 96, 163, 1)",
    color: "white",
  },

  ...(isSelected && {
    color: "white",
    background: "rgba(239, 96, 163, 1)",
  }),
  ...(isPromo && {
    borderColor: theme.palette.primary.main,
    '&:hover': {
      cursor: "pointer",
      backgroundColor: '#8C78A1',
      color: "white",
    },
    position: 'relative'
  }),
  ...(isPromo && isSelected && {
    background: '#8C78A1',
  })
}));

export { Card, DescriptionStack, DetailsStack, LotBox };
